export const getPCSStatusMessage = (pcs: any) => {
  return pcs.topologyEntry?.statusMessage
    ? pcs.topologyEntry?.statusMessage
    : 'N/A'
}
